module.exports = __webpack_public_path__ + "img/education-and-learning.25835a6c.webp";